"use client";
import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { country } from "../../constant/country";
import { postConsultation } from "@/slice/consultationSlice";
import { createPartnerLeadInZoho } from "@/action/zoho";

const ConsultationForm = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    Treatment: "",
    Country: "India",
    CountryCode: "+91",
    Mobile: "",
    City: "",
    Description: "",
    Age: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Submit to Zoho
      const zohoResponse = await createPartnerLeadInZoho({
        First_Name: formData.Name,
        Email: formData.Email,
        Treatment: formData.Treatment,
        Country: formData.Country,
        Phone: formData.Mobile,
        City: formData.City,
        Description: formData.Description,
        Age: formData.Age,
        Mobile_Country_Code: formData.CountryCode,
      });
      if (zohoResponse) {
        setFormData({
          Name: "",
          Email: "",
          Treatment: "",
          Country: "India",
          CountryCode: "+91",
          Mobile: "",
          City: "",
          Description: "",
          Age: "",
        });
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div className="w-full max-w-sm mx-auto bg-white rounded-2xl shadow-lg p-8 h-fit min-w-fit">
      <h2 className="text-[#0066CC] text-base font-bold text-center mb-6">
        Get in Touch with Our Medical Experts
      </h2>

      <div className="space-y-4">
        <div>
          <Input
            className="w-full h-12 px-4 rounded-lg border-gray-200 placeholder-gray-400"
            placeholder="Patient Name"
            value={formData.Name}
            onChange={(e) => setFormData({ ...formData, Name: e.target.value })}
          />
        </div>

        <div>
          <Input
            className="w-full h-12 px-4 rounded-lg border-gray-200 placeholder-gray-400"
            placeholder="Enter Your Email-ID"
            type="email"
            value={formData.Email}
            onChange={(e) =>
              setFormData({ ...formData, Email: e.target.value })
            }
          />
        </div>

        <div>
          <Select
            value={formData.Country}
            onValueChange={(val) => {
              const selectedCountry = country.find((c) => c.name === val);
              setFormData({
                ...formData,
                Country: val,
                CountryCode: selectedCountry?.dial_code || "+91",
              });
            }}
          >
            <SelectTrigger className="w-full h-12">
              <SelectValue placeholder="Select Country" />
            </SelectTrigger>
            <SelectContent>
              {country.map((c) => (
                <SelectItem key={c.name} value={c.name}>
                  {c.flag} {c.name} ({c.dial_code})
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div>
          <Input
            className="w-full h-12 px-4 rounded-lg border-gray-200 placeholder-gray-400"
            placeholder="City"
            value={formData.City}
            onChange={(e) => setFormData({ ...formData, City: e.target.value })}
          />
        </div>

        <div className="flex gap-2">
          <div className="w-20 h-12 flex items-center justify-center bg-gray-100 rounded-lg">
            {formData.CountryCode}
          </div>
          <Input
            className="flex-1 h-12 px-4 rounded-lg border-gray-200 placeholder-gray-400"
            placeholder="Mobile Number"
            value={formData.Mobile}
            onChange={(e) =>
              setFormData({ ...formData, Mobile: e.target.value })
            }
          />
        </div>

        <div>
          <Textarea
            className="w-full p-4 rounded-lg border-gray-200 placeholder-gray-400 min-h-[100px]"
            placeholder="Describe the current medical problem"
            value={formData.Description}
            onChange={(e) =>
              setFormData({ ...formData, Description: e.target.value })
            }
          />
        </div>

        <div>
          <Input
            className="w-full h-12 px-4 rounded-lg border-gray-200 placeholder-gray-400"
            placeholder="Age"
            type="number"
            value={formData.Age}
            onChange={(e) => setFormData({ ...formData, Age: e.target.value })}
          />
        </div>

        <Button
          className="w-full h-12 bg-[#0066CC] hover:bg-[#0052a3] text-white text-lg font-semibold rounded-lg"
          onClick={handleSubmit}
        >
          Get FREE Opinion
        </Button>

        <p className="text-center text-gray-500 text-sm">
          Get First Response Within 4hrs.
        </p>
      </div>
    </div>
  );
};

export default ConsultationForm;
